// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__QA7Kv","errorLogs":"styles_errorLogs__Joq0h"};